import React from 'react';

/**
 * HtmlContent component
 * Renders HTML content safely using dangerouslySetInnerHTML
 * Used to display formatted content from RichTextEditor
 *
 * @param {string} html - The HTML content to render
 */
const HtmlContent = ({ html }) => {
  if (!html) {
    return null;
  }

  return (
    <>
      <style>{`
        .html-content-wrapper img {
          max-width: 100%;
          height: auto;
        }
        .html-content-wrapper p {
          margin: 0.5em 0;
        }
        .html-content-wrapper p:first-child {
          margin-top: 0;
        }
        .html-content-wrapper p:last-child {
          margin-bottom: 0;
        }
        .html-content-wrapper p img[style*="float"] {
          margin-right: 1em;
          margin-bottom: 0.5em;
        }
        .html-content-wrapper::after {
          content: "";
          display: table;
          clear: both;
        }
      `}</style>
      <div
        className="html-content-wrapper"
        style={{
          padding: '10px',
          backgroundColor: '#f9f9f9',
          border: '1px solid #ddd',
          borderRadius: '4px',
          minHeight: '50px',
          maxHeight: '300px',
          overflowY: 'auto'
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </>
  );
};

export default HtmlContent;
